import Vue from 'vue'
import Router from 'vue-router'
import {
    store
} from '../store'


// ============================================ Latino ===============================================
// *** General
const TheContainer = () =>
    import('@/containers/TheContainer')
const Dashboard = () =>
    import('@/views/Dashboard')
const Login = () =>
    import('@/views/pages/Login')
const Register = () =>
    import('@/views/pages/Register')
const Condiciones = () =>
    import('@/views/pages/Condiciones')
const Iniage = () =>
    import('@/views/pages/Iniage')

// *** Domiciliados
const DomiciliadosNuevo = () =>
    import('@/views/cobranza/domiciliados/Nuevo')
const DomiciliadosConsulta = () =>
    import('@/views/cobranza/domiciliados/Consulta');
const DomiciliadosRespuestaBanco = () => 
    import('@/views/cobranza/domiciliados/respuestabanco');
const ConveniosNuevo = () =>
    import('@/views/cobranza/convenios/Nuevo');
const ConveniosConsulta = () =>
    import('@/views/cobranza/convenios/Consulta');

// *** Cotizadores
// Autos
const CotizadorAuto = () =>
    import('@/views/cotizador/autos/Nuevo')

const CotizacionesPolizaAuto = () =>
    import('@/views/cotizador/autos/CotizacionesPolizas')

const MenuEndoso = () =>
    import('@/views/cotizador/autos/MenuEndosos')

const EndosoBAuto = () =>
    import('@/views/cotizador/autos/steps/EndosoB')


// *** Administrador de Tarifas
// Autos
const AdmonTarifas = () =>
import('@/views/administradorTarifas/general')
const RecargoTarifas = () =>
import('@/views/administradorTarifas/recargo')

// APE
const NuevaAPE = () => 
    import('@/views/cotizador/escolar/Nueva')
const CotizacionesPolizasAPE = () => 
    import('@/views/cotizador/escolar/Cotizaciones_Polizas')
const CargaListadoAPE = () => 
    import('@/views/cotizador/escolar/Carga_listado_asegurados')
const AltaAseguradosAPE = () => 
    import('@/views/cotizador/escolar/Tabla_Excel')
const EmisionAPE = () => 
    import('@/views/cotizador/escolar/Emision')
const CondicionesEspe = () => 
    import('@/views/cotizador/escolar/Condiciones_Especiales.vue')
const CondicionesEspeModulos = () => 
    import('@/views/cotizador/escolar/Condiciones_Especiales_Modulos.vue')
const EndososAPE = () => 
    import('@/views/cotizador/escolar/Endosos.vue')
const ListadoAseguradosAPE = () => 
    import('@/views/cotizador/escolar/Lista_Asegurados.vue')
const ListadoEndososAPE = () => 
    import('@/views/cotizador/escolar/Lista_endosos.vue')

// Vida
const ConsultaCotVida = () =>
    import('@/views/cotizador/vida/Consulta')
const NuevaCotVida = () =>
    import('@/views/cotizador/vida/Nueva')


// *** RH
const Empleados = () =>
    import('@/views/rh/Empleados')
const Areas = () =>
    import('@/views/rh/areas/Areas')
const Puestos = () =>
    import('@/views/rh/puestos/Puestos')
const Reportes = () =>
    import('@/views/repo/Reportes')
const IngresoInsumos = () =>
    import('@/views/estadisticasRegulatorias/IngresoInsumos')
const GeneracionDatos = () =>
    import('@/views/estadisticasRegulatorias/GeneracionDatos')
const Salidas = () =>
    import('@/views/estadisticasRegulatorias/Salidas')
const LeadPer = () =>
    import('@/views/leads/LeadPer')
const LeadEmp = () =>
    import('@/views/leads/LeadEmp')

// Herramientas
const NetPayCotizador = () =>
    import("@/views/netpay/cotizador");


// Demos
const FileUpload = () =>
    import("@/views/tools/FileUpload")
const Demo = () =>
    import('@/views/demo/Api')


// ============================================ Template demos ====================
// Views

const Colors = () =>
    import('@/views/theme/Colors')
const Typography = () =>
    import('@/views/theme/Typography')

const Charts = () =>
    import('@/views/charts/Charts')
const Widgets = () =>
    import('@/views/widgets/Widgets')

// Views - Components
const Cards = () =>
    import('@/views/base/Cards')
const Forms = () =>
    import('@/views/base/Forms')
const Switches = () =>
    import('@/views/base/Switches')
const Tables = () =>
    import('@/views/base/Tables')

const Tabs = () =>
    import('@/views/base/Tabs')
const Breadcrumbs = () =>
    import('@/views/base/Breadcrumbs')
const Carousels = () =>
    import('@/views/base/Carousels')
const Collapses = () =>
    import('@/views/base/Collapses')
const Jumbotrons = () =>
    import('@/views/base/Jumbotrons')
const ListGroups = () =>
    import('@/views/base/ListGroups')
const Navs = () =>
    import('@/views/base/Navs')
const Navbars = () =>
    import('@/views/base/Navbars')
const Paginations = () =>
    import('@/views/base/Paginations')
const Popovers = () =>
    import('@/views/base/Popovers')
const ProgressBars = () =>
    import('@/views/base/ProgressBars')
const Tooltips = () =>
    import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () =>
    import('@/views/buttons/StandardButtons')
const ButtonGroups = () =>
    import('@/views/buttons/ButtonGroups')
const Dropdowns = () =>
    import('@/views/buttons/Dropdowns')
const BrandButtons = () =>
    import('@/views/buttons/BrandButtons')

// Views - Icons
const CoreUIIcons = () =>
    import('@/views/icons/CoreUIIcons')
const Brands = () =>
    import('@/views/icons/Brands')
const Flags = () =>
    import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () =>
    import('@/views/notifications/Alerts')
const Badges = () =>
    import('@/views/notifications/Badges')
const Modals = () =>
    import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () =>
    import('@/views/pages/Page404')
const Page500 = () =>
    import('@/views/pages/Page500')

// Users
const Users = () =>
    import('@/views/users/Users')
const User = () =>
    import('@/views/users/User')

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    linkActiveClass: 'active',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: configRoutes()
})

router.beforeEach((to, from, next) => {
    const isRequireAuth = to.matched.some(item => item.meta.requireAuth)
    if (isRequireAuth && store.state.token === null) {
        next('/')
    } else {

        // Middleware
        const grantedRoutes = [];

        store.state.sidebarApps.forEach(route => {
            if (route.items) {
                route.items.forEach(item => grantedRoutes.push(item.to))
            } else if (route.to) {
                grantedRoutes.push(route.to)
            }
        });

        const hasAccess = grantedRoutes.some(route => to.path.toLowerCase().includes(route.toLowerCase()))

        if (grantedRoutes.length > 0) {
            if (!hasAccess && to.path != "/pages/login") {
                console.log("No tienes permisos para acceder a esta ruta", to.path, grantedRoutes);
                // next("/Dashboard");
                // return;
            }
        }

        next()
    }
})

export default router

function configRoutes() {
    return [{
        path: '/',
        redirect: '/pages/login',
        name: 'Inicio',
        component: TheContainer,
        children: [{
            path: 'dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                requireAuth: true
            }
        },
        {
            path: 'rh',
            redirect: '/rh/Empleados',
            name: 'Recursos Humanos',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [{
                path: 'Empleados',
                name: 'Empleados',
                component: Empleados,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'Areas',
                name: 'Areas',
                component: Areas,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'Puestos',
                name: 'Puestos',
                component: Puestos,
                meta: {
                    requireAuth: true
                }
            }
            ]
        },
        {
            path: 'repo',
            redirect: '/repo/Reportes',
            name: 'Reportes',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [{
                path: 'Reportes',
                name: 'Reporte',
                component: Reportes,
                meta: {
                    requiereAuth: true
                }

            }]
        },
        {
            path: 'tarifas',
            name: 'Tarifas',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [{
                path: 'recargo',
                name: 'Recargo',
                component: AdmonTarifas,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'bitacora',
                name: 'Bitacora',
                component: RecargoTarifas,
                meta: {
                    requireAuth: true
                }
            }]
        },
        {
            path: 'estadisticasRegulatorias',
            redirect: '/estadisticasRegulatorias/IngresoInsumos',
            name: 'Estadisticas Regulatorias',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [{
                path: 'IngresoInsumos',
                name: 'Ingreso Insumos',
                component: IngresoInsumos,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'GeneracionDatos',
                name: 'Generación Estadísticas',
                component: GeneracionDatos,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'Salidas',
                name: 'Generación Archivos de Salida',
                component: Salidas,
                meta: {
                    requireAuth: true
                }
            }
            ]
        },
        {
            path: 'cobranza',
            name: 'Cobranza',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [{
                path: 'domiciliados/lote/:id?',
                name: 'Nuevo lote de pago',
                component: DomiciliadosNuevo,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'domiciliados/consulta',
                name: 'Consulta lote',
                component: DomiciliadosConsulta,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'domiciliados/respuestabanco',
                name: 'Respuesta banco',
                component: DomiciliadosRespuestaBanco,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'convenios',
                name: 'Nuevo convenio',
                component: ConveniosNuevo,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'convenios/consulta',
                name: 'Consulta convenio',
                component: ConveniosConsulta,
                meta: {
                    requireAuth: true
                }
            },
            ]
        },

        {
            path: 'cotizador/escuelas',
            name: '',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [{
                path: 'nuevo',
                name: 'Nueva Cotización',
                component: NuevaAPE
            },
            {
                path: 'cotizaciones',
                name: 'Cotizaciones y Polizas',
                component: CotizacionesPolizasAPE
            },
            {
                path: 'cargaListado',
                name: 'Carga Layout',
                component: CargaListadoAPE
            },
            {
                path: 'alta',
                name: 'Alta Asegurados',
                component: AltaAseguradosAPE
            },
            {
                path: 'emision',
                name: 'Proceso Emisión',
                component: EmisionAPE
            },
            {
                path: 'condiciones',
                name: 'Condiciones Especiales',
                component: CondicionesEspe
            },
            {
                path: 'condicionesModulos',
                name: 'Condiciones Especiales Modulos',
                component: CondicionesEspeModulos
            },
            {
                path: 'endosos',
                name: 'Endosos',
                component: EndososAPE
            },
            {
                path: 'listado',
                name: 'Listado Asegurados',
                component: ListadoAseguradosAPE
            },
            {
                path: 'listadoEndosos',
                name: 'Endosos',
                component: ListadoEndososAPE
            }
            
        ],
        },


        {
            path: 'cotizador',
            // redirect: '/theme/colors',
            name: 'Cotizadores',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [{
                path: 'auto',
                name: 'Autos',
                component: CotizadorAuto
            },
            {
                path: 'auto/cotizaciones-poliza',
                name: 'Cotizaciones poliza',
                component: CotizacionesPolizaAuto
            },
            {
                path: 'auto/menu-endoso',
                name: 'Menu Endoso',
                component: MenuEndoso
            },
            {
                path: 'auto/endoso-b',
                name: 'Endosos',
                component: EndosoBAuto
            },

            // Cotizador de vida
            {
                path: 'vida/consulta',
                name: 'Consulta cotización',
                component: ConsultaCotVida,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'vida',
                name: 'Nueva cotización',
                component: NuevaCotVida,
                meta: {
                    requireAuth: true
                }
            },
            ]
        },



        // {
        //     path: '/cotizador/consulta',
        //     name: 'Consulta cotización',
        //     component: ConsultaCotVida,
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        // {
        //     path: '/cotizador/nueva/:id?/:idLinea?/:numCot?',
        //     name: 'Nueva cotización',
        //     component: NuevaCotVida,
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        {
            path: '/demo/api',
            name: 'Demo',
            component: Demo
        },
        {
            path: '/uploads/demo',
            name: 'Uploads',
            component: FileUpload
        },

            // {
            //     path: 'theme',
            //     redirect: '/theme/colors',
            //     name: 'Theme',
            //     component: {
            //         render(c) {
            //             return c('router-view')
            //         }
            //     },
            //     children: [{
            //             path: 'colors',
            //             name: 'Colors',
            //             component: Colors
            //         },
            //         {
            //             path: 'typography',
            //             name: 'Typography',
            //             component: Typography
            //         }
            //     ]
            // },
            // {
            //     path: 'charts',
            //     name: 'Charts',
            //     component: Charts
            // },
            // {
            //     path: 'widgets',
            //     name: 'Widgets',
            //     component: Widgets
            // },
            // {
            //     path: 'users',
            //     meta: {
            //         label: 'Users'
            //     },
            //     component: {
            //         render(c) {
            //             return c('router-view')
            //         }
            //     },
            //     children: [{
            //             path: '',
            //             name: 'Users',
            //             component: Users
            //         },
            //         {
            //             path: ':id',
            //             meta: {
            //                 label: 'User Details'
            //             },
            //             name: 'User',
            //             component: User
            //         }
            //     ]
            // },
            // {
            //     path: 'base',
            //     redirect: '/base/cards',
            //     name: 'Base',
            //     component: {
            //         render(c) {
            //             return c('router-view')
            //         }
            //     },
            //     children: [{
            //             path: 'cards',
            //             name: 'Cards',
            //             component: Cards
            //         },
            //         {
            //             path: 'forms',
            //             name: 'Forms',
            //             component: Forms
            //         },
            //         {
            //             path: 'switches',
            //             name: 'Switches',
            //             component: Switches
            //         },
            //         {
            //             path: 'tables',
            //             name: 'Tables',
            //             component: Tables
            //         },
            //         {
            //             path: 'tabs',
            //             name: 'Tabs',
            //             component: Tabs
            //         },
            //         {
            //             path: 'breadcrumbs',
            //             name: 'Breadcrumbs',
            //             component: Breadcrumbs
            //         },
            //         {
            //             path: 'carousels',
            //             name: 'Carousels',
            //             component: Carousels
            //         },
            //         {
            //             path: 'collapses',
            //             name: 'Collapses',
            //             component: Collapses
            //         },
            //         {
            //             path: 'jumbotrons',
            //             name: 'Jumbotrons',
            //             component: Jumbotrons
            //         },
            //         {
            //             path: 'list-groups',
            //             name: 'List Groups',
            //             component: ListGroups
            //         },
            //         {
            //             path: 'navs',
            //             name: 'Navs',
            //             component: Navs
            //         },
            //         {
            //             path: 'navbars',
            //             name: 'Navbars',
            //             component: Navbars
            //         },
            //         {
            //             path: 'paginations',
            //             name: 'Paginations',
            //             component: Paginations
            //         },
            //         {
            //             path: 'popovers',
            //             name: 'Popovers',
            //             component: Popovers
            //         },
            //         {
            //             path: 'progress-bars',
            //             name: 'Progress Bars',
            //             component: ProgressBars
            //         },
            //         {
            //             path: 'tooltips',
            //             name: 'Tooltips',
            //             component: Tooltips
            //         }
            //     ]
            // },
            // {
            //     path: 'buttons',
            //     redirect: '/buttons/standard-buttons',
            //     name: 'Buttons',
            //     component: {
            //         render(c) {
            //             return c('router-view')
            //         }
            //     },
            //     children: [{
            //             path: 'standard-buttons',
            //             name: 'Standard Buttons',
            //             component: StandardButtons
            //         },
            //         {
            //             path: 'button-groups',
            //             name: 'Button Groups',
            //             component: ButtonGroups
            //         },
            //         {
            //             path: 'dropdowns',
            //             name: 'Dropdowns',
            //             component: Dropdowns
            //         },
            //         {
            //             path: 'brand-buttons',
            //             name: 'Brand Buttons',
            //             component: BrandButtons
            //         }
            //     ]
            // },
            // {
            //     path: 'icons',
            //     redirect: '/icons/coreui-icons',
            //     name: 'CoreUI Icons',
            //     component: {
            //         render(c) {
            //             return c('router-view')
            //         }
            //     },
            //     children: [{
            //             path: 'coreui-icons',
            //             name: 'Icons library',
            //             component: CoreUIIcons
            //         },
            //         {
            //             path: 'brands',
            //             name: 'Brands',
            //             component: Brands
            //         },
            //         {
            //             path: 'flags',
            //             name: 'Flags',
            //             component: Flags
            //         }
            //     ]
            // },
            // {
            //     path: 'notifications',
            //     redirect: '/notifications/alerts',
            //     name: 'Notifications',
            //     component: {
            //         render(c) {
            //             return c('router-view')
            //         }
            //     },
            //     children: [{
            //             path: 'alerts',
            //             name: 'Alerts',
            //             component: Alerts
            //         },
            //         {
            //             path: 'badges',
            //             name: 'Badges',
            //             component: Badges
            //         },
            //         {
            //             path: 'modals',
            //             name: 'Modals',
            //             component: Modals
            //         }
            //     ]
            // }
        ]
    },
    {
        path: '/pages',
        redirect: '/pages/404',
        name: 'Pages',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
            path: '404',
            name: 'Page404',
            component: Page404
        },
        {
            path: '500',
            name: 'Page500',
            component: Page500
        },
        {
            path: 'login/:idUsuario?/:token?',
            name: 'Login',
            component: Login
        },
        {
            path: 'register',
            name: 'Register',
            component: Register
        },
        {
            path: 'payment/cotizador',
            name: 'payment',
            component: NetPayCotizador,
        },
        {
            path: 'condiciones-generales',
            name: 'condiciones',
            component: Condiciones,
        },
        {
            path: 'inicio-agentes',
            name: 'iniage',
            component: Iniage,
        },
        ]
    },
    {
        path: '/leads',
        redirect: '/leads/Lead',
        name: 'leads',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
            path: 'LeadPer',
            name: 'Personas',
            component: LeadPer
        },
        {
            path: 'LeadEmp',
            name: 'Empresas',
            component: LeadEmp
        }
        ]
    },
    // {
    //     path: '/tarifas',
    //     redirect: '/tarifas/recargo',
    //     name: 'AdministradorTarifas',
    //     component: {
    //         render(c) {
    //             return c('router-view')
    //         }
    //     },
    //     children: [{
    //         path: 'recargo',
    //         name: 'Recargo',
    //         component: AdmonTarifas,
    //     },
    //     {
    //         path: 'bitacora',
    //         name: 'Bitacora',
    //         component: RecargoTarifas
    //     }
    //     ]
    // },
    // {
    //     path: '/tarifas',
    //     name: 'Tarifas',
    //     component: {
    //         render(c) {
    //             return c('router-view')
    //         }
    //     },
    //     children: [{
    //         path: 'recargo',
    //         name: 'Recargo',
    //         component: AdmonTarifas,
    //         meta: {
    //             requireAuth: true
    //         }
    //     },
    //     {
    //         path: 'bitacora',
    //         name: 'Bitacora',
    //         component: RecargoTarifas,
    //         meta: {
    //             requireAuth: true
    //         }
    //     },
    // ]}
    ]
}